
















































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import SuporteHospitaisStore from '@/components/Suporte/Store/SuporteHospitaisStore'

const ACCEPT_TYPES = ['image/jpeg', 'image/jpg', 'image/jpe', 'image/png', 'image/webp', 'image/svg+xml']
const MAX_WIDTH_PX = 250
const MAX_FILE_SIZE_MB = 1
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024

@Component
export default class ModalSuporteHospitalLogo extends Vue {
  $refs!: {
    fileInput: HTMLInputElement,
  }

  imagePreview: string = ''
  isDragging: boolean = false
  loadingUpload: boolean = false
  uploadError: string = ''

  get getSuporteHospitaisStore() {
    return getModule(SuporteHospitaisStore, this.$store)
  }

  get showModalHospitalLogo() {
    return this.getSuporteHospitaisStore.modal.hospitalLogo
  }

  set showModalHospitalLogo(value: boolean) {
    this.getSuporteHospitaisStore.setModal({ name: 'hospitalLogo', value })
  }

  get hospitalNome() {
    const item = this.getSuporteHospitaisStore.hospitalLogoItem
    return item ? item.nome : ''
  }

  triggerFileInput() {
    this.$refs.fileInput.click()
  }

  onFileChange(event: Event) {
    const input = event.target as HTMLInputElement
    const file = input.files && input.files[0]
    if (file) this.processFile(file)
    input.value = ''
  }

  onDrop(event: DragEvent) {
    this.isDragging = false
    const file = event.dataTransfer && event.dataTransfer.files[0]
    if (file) this.processFile(file)
  }

  processFile(file: File) {
    this.uploadError = ''
    if (!ACCEPT_TYPES.includes(file.type)) {
      this.uploadError = 'Formato inválido. Use imagens JPEG, PNG, WebP ou SVG.'
      this.imagePreview = ''
      return
    }
    if (file.size > MAX_FILE_SIZE_BYTES) {
      this.uploadError = `Arquivo muito grande. O tamanho máximo permitido é ${MAX_FILE_SIZE_MB} MB.`
      this.imagePreview = ''
      return
    }
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = (ev: ProgressEvent) => {
      const dataUrl = (ev.target as FileReader).result as string
      const img = document.createElement('img')
      img.src = dataUrl
      img.onload = () => {
        if (img.naturalWidth > MAX_WIDTH_PX) {
          this.uploadError = `A largura da imagem (${img.naturalWidth}px) excede o máximo de ${MAX_WIDTH_PX}px.`
          this.imagePreview = ''
          return
        }
        this.imagePreview = dataUrl
      }
    }
  }

  async enviarLogo() {
    if (!this.imagePreview) return
    this.uploadError = ''
    this.loadingUpload = true
    const response = await this.getSuporteHospitaisStore.uploadHospitalLogo(this.imagePreview)
    this.loadingUpload = false
    if (response && response.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Logo enviada com sucesso!',
        icon: 'done',
        color: '#2E7D32',
      })
      this.showModalHospitalLogo = false
    } else {
      this.uploadError = (response && response.message) || 'Ocorreu um erro ao enviar a logo.'
    }
  }

  resetModal() {
    this.imagePreview = ''
    this.uploadError = ''
    this.isDragging = false
    if (this.$refs.fileInput) this.$refs.fileInput.value = ''
    this.getSuporteHospitaisStore.clearHospitalLogoItem()
  }

  @Watch('showModalHospitalLogo')
  onShowModalChange(value: boolean) {
    if (!value) {
      this.resetModal()
      return
    }
    this.imagePreview = this.getSuporteHospitaisStore.currentHospitalLogo || ''
  }
}
